import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	transactions: [],
};

const transactionsSlice = createSlice({
	name: 'transactions',
	initialState: initialState,
	reducers: {
		setTransactions: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setTransactions, reset } = transactionsSlice.actions;

export default transactionsSlice.reducer;